export class ContactSourcesConstants {
  static ONLINE_REGISTRATION = 35;
}
